export default __webpack_public_path__ + "static/media/rackspace.b434b325.svg";